/**
 * UI Helper Utilities
 * Provides global UI functions like toast notifications and modal management
 */

/**
 * Display a toast notification
 * @param {string} message - The message to display
 * @param {string} type - Type of toast: 'success', 'error', 'info', 'warning'
 */
export const ogToast = (message, type = 'success') => {
  let container = document.getElementById('og-toast-container');
  if (!container) {
    container = document.createElement('div');
    container.id = 'og-toast-container';
    container.style.cssText = 'position:fixed;top:20px;right:20px;z-index:9999;';
    document.body.appendChild(container);
  }

  const toast = document.createElement('div');
  const bgColor = {
    success: '#10b981',
    error: '#ef4444',
    info: '#3b82f6',
    warning: '#f59e0b'
  }[type] || '#10b981';

  toast.style.cssText = `
    background:${bgColor};
    color:white;
    padding:12px 16px;
    border-radius:6px;
    margin-bottom:8px;
    box-shadow:0 4px 12px rgba(0,0,0,0.15);
    font-size:14px;
    animation:slideIn 0.3s ease;
  `;
  toast.textContent = message;
  container.appendChild(toast);

  // Auto remove after 3 seconds
  setTimeout(() => toast.remove(), 3000);
};

/**
 * Open a modal by ID
 * @param {string} modalId - The ID of the modal to open
 */
export const ogOpenModal = (modalId) => {
  const modal = document.getElementById(modalId);
  if (modal) {
    modal.classList.add('open');
    console.log(`Modal ${modalId} opened`);
  } else {
    console.warn(`Modal with ID ${modalId} not found`);
  }
};

/**
 * Close a modal by ID
 * @param {string} modalId - The ID of the modal to close
 */
export const ogCloseModal = (modalId) => {
  const modal = document.getElementById(modalId);
  if (modal) {
    modal.classList.remove('open');
    console.log(`Modal ${modalId} closed`);
  } else {
    console.warn(`Modal with ID ${modalId} not found`);
  }
};

export default {
  ogToast,
  ogOpenModal,
  ogCloseModal
};
